"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx } from "react/jsx-runtime";
import React from "react";
import $ from "jquery";
import Geosuggest from "react-geosuggest";
import ReactDOM from "react-dom";
import { attachOcrLineDropListeners, forceString } from "./ocr_line_drop";
function cleanedProps(props) {
  const cleaned = Object.assign({}, props);
  if (typeof cleaned.inputDropped !== "undefined") {
    delete cleaned.inputDropped;
  }
  if (cleaned.initialValue === null) {
    cleaned.initialValue = "";
  }
  return cleaned;
}
function nonSelect(props, value) {
  props.nonSelect.requestChange(value);
}
class GeosuggestDroppableInput extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "detachOcrLineDrop");
    __publicField(this, "applyDroppedChars", (chars) => {
      const input = this.refs.input;
      input.update(forceString(chars));
      input.focus();
    });
    __publicField(this, "onSuggestSelect", (suggest) => {
      if (suggest == void 0) {
        this.props.geosuggestClear.requestChange();
        this.refs.input.clear();
      } else {
        this.props.onSuggestionSelected(suggest);
      }
    });
  }
  componentDidMount() {
    const suggestInput = ReactDOM.findDOMNode(this.refs.input).querySelector("input");
    $(suggestInput).droppable({
      drop: (event, ui) => {
        this.applyDroppedChars(ui.helper.data("chars"));
      },
      scope: "dnd-text",
      activeClass: "ocred-document__drop-target"
    });
    this.detachOcrLineDrop = attachOcrLineDropListeners(
      suggestInput,
      (payload) => this.applyDroppedChars(payload.chars)
    );
  }
  componentWillUnmount() {
    if (this.detachOcrLineDrop) {
      this.detachOcrLineDrop();
    }
  }
  render() {
    return /* @__PURE__ */ jsx(
      Geosuggest,
      __spreadProps(__spreadValues({
        "data-component": "GeosuggestDroppableInput",
        ref: "input"
      }, cleanedProps(this.props)), {
        placeDetailFields: ["address_components"],
        onSuggestSelect: this.onSuggestSelect,
        onBlur: (value) => nonSelect(this.props, value)
      })
    );
  }
}
export default GeosuggestDroppableInput;
